var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#008B44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3229_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7H25.5V25H7.5V7Z",
    fill: "#008B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 23.5C10.5 21.9087 11.1321 20.3826 12.2574 19.2574C13.3826 18.1321 14.9087 17.5 16.5 17.5C18.0913 17.5 19.6174 18.1321 20.7426 19.2574C21.8679 20.3826 22.5 21.9087 22.5 23.5H21C21 22.3065 20.5259 21.1619 19.682 20.318C18.8381 19.4741 17.6935 19 16.5 19C15.3065 19 14.1619 19.4741 13.318 20.318C12.4741 21.1619 12 22.3065 12 23.5H10.5ZM16.5 16.75C14.0138 16.75 12 14.7362 12 12.25C12 9.76375 14.0138 7.75 16.5 7.75C18.9862 7.75 21 9.76375 21 12.25C21 14.7362 18.9862 16.75 16.5 16.75ZM16.5 15.25C18.1575 15.25 19.5 13.9075 19.5 12.25C19.5 10.5925 18.1575 9.25 16.5 9.25C14.8425 9.25 13.5 10.5925 13.5 12.25C13.5 13.9075 14.8425 15.25 16.5 15.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3229_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPatient);
export default __webpack_public_path__ + "static/media/totalPatient.1e9ba069a280e6d660b1d7a412cdbdb7.svg";
export { ForwardRef as ReactComponent };